import React, { Component } from 'react';
import { keyBy, forEach, toString, get } from 'lodash';
import { Row, Col, Form, Select } from 'antd';
import validator from 'validator';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  FormTitle,
  StyledFormItem,
  ItemWrapper,
  ItemButton,
  StyledInput,
  StyledInputNumber,
  StyledSelect,
  StyledButton,
  RemoveButton
} from 'components/Styled';
import CategorySelect from './CategorySelect';
import helpers from 'utils/helpers';
import currency from 'utils/currency';
import categories from 'data/categories';
import currencies from 'data/currencies';
import countries from 'data/countries';
import ReactCountryFlag from 'react-country-flag';

const keyedCategories = keyBy(categories, 'id');
const CATEGORY_DOCUMENT = '119';

const { Option } = Select;

class ItemCard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      mainCategory: '',
      category: '',
      description: '',
      remarks: '',
      value: 0,
      currency: props.itemCurrency,
      countryOfManufacture: 'CN',
      quantity: 0,
      cardHeight: '480px'
    };

    this.value = new currency({
      currency: props.itemCurrency,
      amount: 0,
      minor: 2
    });
  }

  autoSave = () => {
    this.props.autoSave();
  };

  handleMainCategoryChange = value => {
    this.setState(
      {
        mainCategory: value,
        category: '',
        categoryChanged: undefined
      },
      this.autoSave
    );

    if (value === CATEGORY_DOCUMENT) {
      this.setState(
        {
          value: 1,
          currency: 'auto'
        },
        () => {
          this.handleTextInputBlur('value');
        }
      );
    }
  };

  handleTextInputChange = (value, name) => {
    if (name === 'value') {
      const v = value * 10 ** this.value.minor - this.value.amount;
      this.value.add({ amount: v });
    }

    this.setState({
      [name]: value
    });
  };

  handleTextInputBlur = name => {
    this.setState(
      {
        [name + 'Status']: this.validateError(name) ? 'error' : '',
        [name + 'Help']: this.validateError(name)
      },
      this.autoSave
    );
  };

  handleInputChange = (value, name) => {
    this.setState(
      {
        [name]: value,
        [name + 'Changed']: true
      },
      () => {
        this.setState(
          {
            [name + 'Status']: this.validateError(name) ? 'error' : '',
            [name + 'Help']: this.validateError(name)
          },
          this.autoSave
        );
      }
    );
  };

  handleInputBlur = name => {
    this.setState(
      {
        [name + 'Changed']: true
      },
      () => {
        this.setState({
          [name + 'Status']: this.validateError(name) ? 'error' : '',
          [name + 'Help']: this.validateError(name)
        });
      }
    );
  };

  handleCurrencyChange = value => {
    this.setState({
      currency: value
    });
  };

  handleCountryChange = value => {
    this.setState({
      countryOfManufacture: value
    });
  };

  validate = () => {
    const fields = [
      'category',
      'description',
      'remarks',
      'value',
      'currency',
      'quantity',
      'countryOfManufacture'
    ];

    const states = {};
    forEach(fields, field => {
      states[field + 'Changed'] = true;
      states[field + 'Status'] = this.validateError(field) ? 'error' : '';
      states[field + 'Help'] = this.validateError(field);
    });

    this.setState(states);

    for (var i = 0; i < fields.length; i++) {
      if (this.validateError(fields[i])) {
        return false;
      }
    }
    return true;
  };

  getItemData = () => {
    const {
      mainCategory,
      category,
      description,
      remarks,
      value,
      currency,
      quantity,
      countryOfManufacture
    } = this.state;
    return {
      mainCategory,
      category,
      description,
      remarks,
      value,
      currency,
      quantity,
      countryOfManufacture
    };
  };

  validateType = {
    category: 'required',
    description: 'required',
    value: 'number',
    currency: 'required',
    quantity: 'number',
    countryOfManufacture: 'required'
  };

  validateError = name => {
    let patterns;
    const value = toString(this.state[name]);

    if (name !== 'remarks' && value.length > 35) {
      return this.props.t('common.err_msg.length');
    }

    switch (this.validateType[name]) {
      case 'required':
        patterns = /^[0-9A-Z\s\-.,/'"():;$&@!?]+$/i;

        if (validator.isEmpty(value, { ignore_whitespace: true })) {
          return `items.err_msg.${name}.empty`;
        }
        if (!patterns.test(value)) {
          return `items.err_msg.${name}.format`;
        }
        return null;
      case 'number':
        if (value <= 0) {
          return `items.err_msg.${name}.empty`;
        }
        return null;
      default:
        return null;
    }
  };

  handleConfirmClick = () => {
    const success = this.validate();

    if (!success) {
      return helpers.scrollToError();
    }

    const itemsData = this.getItemData();
    itemsData.category = get(keyedCategories[itemsData.category], 'name.en');

    window.dataLayer.push({
      event: 'Confirm Product',
      ecommerce: undefined,
      itemsData: JSON.stringify(itemsData)
    });

    this.props.changeActiveCard(-1);
  };

  handleBodyClick = () => {
    this.props.changeActiveCard(this.props.expand ? -1 : this.props.index);
  };

  handleRemoveClick = e => {
    e.stopPropagation();
    this.props.removeCard(this.props.index);
  };

  handelLinkClick = () => {
    window.open(this.props.t('items.form.item_desc_sublabel_url'));
  };

  componentDidMount() {
    if (this.props.data) {
      this.setState({ ...this.props.data });
    } else if (this.props.showDocument) {
      this.handleMainCategoryChange(CATEGORY_DOCUMENT);
    }

    if (this.props.itemType === 'return_goods') {
      this.setState({
        value: this.state.mainCategory === CATEGORY_DOCUMENT ? 1 : 50,
        currency: 'auto'
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.itemType === 'return_goods' &&
      this.props.itemType !== prevProps.itemType
    ) {
      this.setState({
        value: this.state.mainCategory === CATEGORY_DOCUMENT ? 1 : 50,
        currency: 'auto'
      });
    }
  }

  componentWillUpdate(nextProps, nextState) {
    if (nextState?.currency && nextState?.value) {
      this.value.currency =
        nextState.currency === 'auto'
          ? this.props.itemCurrency
          : nextState.currency;
      this.value.amount = nextState.value * 10 ** this.value.minor;
    }
  }

  generateCountryOptions = () => {
    return countries.map(c => (
      <Option
        key={c['alpha-2']}
        value={c['alpha-2']}
        display={c.name[this.props.t('key')]}>
        <Row type="flex">
          <Col>
            <ReactCountryFlag
              countryCode={c['alpha-2']}
              style={{ width: 20, height: 20, padding: '0 8px 4px 0' }}
              svg
            />
          </Col>
          <Col style={{ flex: 1 }}>
            {c.name[this.props.t('key')]}
            {this.props.t('key') !== 'en' && (
              <div style={{ fontSize: '12px', marginTop: '-8px' }}>
                {c.name.en}
              </div>
            )}
          </Col>
        </Row>
      </Option>
    ));
  };

  render() {
    return (
      <ItemWrapper>
        <ItemButton
          className="theme-button"
          ghost
          onClick={this.handleBodyClick}>
          <Row type="flex" align="middle">
            <Col span={3}>
              <div
                style={{
                  width: '24px',
                  height: '24px',
                  fontSize: '10px',
                  color: '#ccc',
                  border: 'solid 1px #ccc',
                  borderRadius: '99px',
                  textAlign: 'center',
                  lineHeight: '22px'
                }}>
                {this.props.index + 1}
              </div>
            </Col>
            <Col span={3}>
              <div
                style={{
                  fontSize: '18px',
                  opacity: this.state.category ? 1 : 0
                }}>
                {keyedCategories[this.state.category] &&
                  keyedCategories[this.state.category].icon}
              </div>
            </Col>
            <Col span={9}>
              <div
                style={{
                  fontWeight: 700,
                  color: '#2C2C2E',
                  whiteSpace: 'normal',
                  opacity: this.state.category ? 1 : 0
                }}>
                {keyedCategories[this.state.category] &&
                  keyedCategories[this.state.category].name[
                    this.props.t('key')
                  ]}
                {'　'}
              </div>
              <div
                style={{
                  fontSize: '11px',
                  color: '#2C2C2E',
                  opacity: this.state.category ? 1 : 0
                }}>
                ✕ {this.state.quantity}
              </div>
            </Col>
            <Col span={6} style={{ textAlign: 'right' }}>
              {!(
                this.state.mainCategory === CATEGORY_DOCUMENT ||
                this.props.itemType === 'return_goods'
              ) && (
                <div
                  style={{
                    fontSize: '11px',
                    color: '#2C2C2E',
                    opacity: this.state.category ? 1 : 0
                  }}>
                  {this.value.format()}
                </div>
              )}
            </Col>
            <Col span={2} offset={1} style={{ textAlign: 'right' }}>
              <RemoveButton
                type="primary"
                shape="circle"
                className="theme-button buttonTheme-background border-buttonTheme-color blank-color"
                onClick={this.handleRemoveClick}>
                ✕
              </RemoveButton>
            </Col>
          </Row>
        </ItemButton>
        <div
          style={{
            height: this.props.expand ? this.state.cardHeight : 0,
            padding: '0 15px',
            overflow: 'hidden',
            transition: 'height .3s'
          }}>
          <div style={{ paddingTop: '2px' }}>
            <Form>
              <CategorySelect
                t={this.props.t}
                mainCategory={this.state.mainCategory}
                category={this.state.category}
                onMainCategoryChange={this.handleMainCategoryChange}
                onCategoryChange={value => {
                  this.handleInputChange(value, 'category');
                }}
                onCategoryBlur={() => {
                  this.handleInputBlur('category');
                }}
                categoryChanged={this.state.categoryChanged}
                categoryStatus={this.state.categoryStatus}
                categoryHelp={this.props.t(this.state.categoryHelp)}
              />
              <Row gutter={14} style={{ paddingTop: '20px' }}>
                <Col span={24}>
                  <FormTitle>
                    {this.props.t('items.form.item_desc_label')}
                  </FormTitle>
                  <div
                    style={{
                      color: '#2C2C2E',
                      fontSize: '12px',
                      marginBottom: '2px'
                    }}>
                    <span
                      className="buttonSecond-color"
                      style={{
                        fontWeight: 'bold',
                        color: '#9900a5',
                        marginLeft: '2px',
                        cursor: 'pointer'
                      }}
                      onClick={this.handelLinkClick}>
                      <span style={{ margin: '0px 2px' }}>
                        {this.props.t('items.form.item_desc_sublabel_redir')}
                      </span>
                      <FontAwesomeIcon icon="external-link-alt" />
                    </span>
                    {this.props.t('items.form.item_desc_sublabel')}
                  </div>
                  <StyledFormItem
                    validateStatus={this.state['descriptionStatus'] || ''}
                    help={this.props.t(this.state['descriptionHelp'])}>
                    <StyledInput
                      size="large"
                      value={this.state['description']}
                      onChange={e => {
                        this.handleTextInputChange(
                          e.target.value,
                          'description'
                        );
                      }}
                      placeholder={this.props.t('items.form.placeholder.desc')}
                      onBlur={e => {
                        this.handleTextInputBlur('description');
                      }}
                    />
                  </StyledFormItem>
                </Col>
              </Row>

              <Row gutter={14} style={{ paddingTop: '20px' }}>
                <Col span={24}>
                  <FormTitle>
                    {this.props.t('items.form.item_remarks_label')}
                    <span
                      style={{
                        fontSize: '12px',
                        lineHeight: '24px',
                        color: '#ced4da'
                      }}>
                      {' '}
                      {this.props.t('items.form.item_remarks_label_optional')}
                    </span>
                  </FormTitle>
                  <StyledFormItem
                    validateStatus={this.state['remarksStatus'] || ''}
                    help={this.props.t(this.state['remarksHelp'])}>
                    <StyledInput
                      size="large"
                      value={this.state['remarks']}
                      placeholder={this.props.t(
                        'items.form.placeholder.remarks'
                      )}
                      onChange={e => {
                        this.handleTextInputChange(e.target.value, 'remarks');
                      }}
                      onBlur={e => {
                        this.handleTextInputBlur('remarks');
                      }}
                    />
                  </StyledFormItem>
                </Col>
              </Row>
              <Row gutter={14} style={{ paddingTop: '20px' }}>
                <Col span={24}>
                  <FormTitle>
                    {this.props.t('items.form.item_label_origin')}
                    <span
                      style={{
                        fontSize: '12px',
                        lineHeight: '24px',
                        color: '#ced4da'
                      }}>
                      {' '}
                    </span>
                  </FormTitle>
                  <StyledFormItem
                    validateStatus={
                      this.state['countryOfManufactureStatus'] || ''
                    }
                    help={this.props.t(this.state['countryOfManufactureHelp'])}>
                    <StyledSelect
                      size="large"
                      value={this.state.countryOfManufacture}
                      placeholder={this.props.t(
                        'items.form.placeholder.origin'
                      )}
                      onChange={this.handleCountryChange}>
                      {this.generateCountryOptions()}
                    </StyledSelect>
                  </StyledFormItem>
                </Col>
              </Row>
              <Row gutter={14} style={{ paddingTop: '20px' }}>
                <Col span={12}>
                  <FormTitle>
                    {this.props.t('items.form.item_quantity_label')}
                  </FormTitle>
                  <StyledFormItem
                    validateStatus={this.state['quantityStatus'] || ''}
                    help={this.props.t(this.state['quantityHelp'])}>
                    <StyledInputNumber
                      size="large"
                      value={this.state['quantity'] || null}
                      onChange={value => {
                        this.handleTextInputChange(value, 'quantity');
                      }}
                      onBlur={e => {
                        this.handleTextInputBlur('quantity');
                      }}
                      precision={0}
                      min={0}
                      inputMode="decimal"
                      placeholder="0"
                    />
                  </StyledFormItem>
                </Col>
                {!(
                  this.state.mainCategory === CATEGORY_DOCUMENT ||
                  this.props.itemType === 'return_goods'
                ) && (
                  <Col span={12} style={{ display: 'flex' }}>
                    <div style={{ flex: '0 0 90px' }}>
                      <FormTitle>
                        {this.props.t('items.form.item_value_label')}
                      </FormTitle>
                      <StyledSelect
                        item="true"
                        size="large"
                        placeholder={this.props.t('common.select')}
                        value={
                          this.state.currency === 'auto'
                            ? this.props.itemCurrency
                            : this.state.currency
                        }
                        onChange={this.handleCurrencyChange}>
                        {currencies.map(currency => (
                          <Option key={currency.code}>{currency.code}</Option>
                        ))}
                      </StyledSelect>
                    </div>
                    <div style={{ flex: '1 1 auto', marginLeft: '-1px' }}>
                      <FormTitle>{'　'}</FormTitle>
                      <StyledFormItem
                        validateStatus={this.state['valueStatus'] || ''}
                        help={this.props.t(this.state['valueHelp'])}>
                        <StyledInputNumber
                          size="large"
                          value={this.state['value'] || null}
                          onChange={value => {
                            this.handleTextInputChange(value, 'value');
                          }}
                          onBlur={e => {
                            this.handleTextInputBlur('value');
                          }}
                          precision={2}
                          min={0}
                          inputMode="decimal"
                          placeholder="0"
                          style={{
                            borderRadius: '0 4px 4px 0'
                          }}
                        />
                      </StyledFormItem>
                    </div>
                  </Col>
                )}
              </Row>
              <div
                style={{
                  height: '0',
                  overflow: 'hidden',
                  textAlign: 'center'
                }}>
                <StyledButton
                  ghost
                  type="primary"
                  width={165}
                  onClick={this.handleConfirmClick}
                  style={{
                    display: 'none'
                  }}
                  htmlType="submit">
                  {this.props.t('button.confirm')}
                </StyledButton>
              </div>
            </Form>
          </div>
        </div>
      </ItemWrapper>
    );
  }
}

export default ItemCard;
